export class CrewInfo {
    type: string;
    email: string;
    firstName: string;
    fullName: string;
    active: boolean;
    code: Code;
    company?: string;
}
export class Code {
    type: string;
    value: string;
}